import { IFrequencyCap } from '../entities/frequency-caps';
import * as React from 'react';
import { IValue as ImportedValue, FrequencyCapsProvider } from './FrequencyCapsProvider';
import { ActionTypes, FrequencyCapsReducer } from './FrequencyCapsReducer';

export type IValue = ImportedValue;

export interface IAction {
  type: ActionTypes;
  payload?: any;
}

export interface IConfiguredDispatcher {
  id: string;
  ownerId: string;
  dispatcher: string;
}

export type Dispatch = (action: IAction) => void;

export interface IState {
  originalFrequencyCap: IFrequencyCap;
  frequencyCap: IFrequencyCap;
  isInitialised: boolean;
}

export const defaultContextValues: IState = {
  isInitialised: false,
  originalFrequencyCap: {
    id: '',
    siteId: '',
    amount: 1,
    period: 3600000,
    type: 'abandonmentsPerPeriod',
    createdAt: -1,
    createdById: '',
    updatedAt: -1,
    updatedById: '',
  },
  frequencyCap: {
    id: '',
    siteId: '',
    amount: 1,
    period: 3600000,
    type: 'abandonmentsPerPeriod',
    createdAt: -1,
    createdById: '',
    updatedAt: -1,
    updatedById: '',
  },
};

export const FrequencyCapsStateContext = React.createContext<IState | undefined>(undefined);
export const FrequencyCapsDispatchContext = React.createContext<Dispatch | undefined>(undefined);

function useFrequencyCapsState() {
  const context = React.useContext(FrequencyCapsStateContext);
  if (context === undefined) {
    throw new Error('useFrequencyCapsState must be used within a FrequencyCapsProvider');
  }
  return context;
}

function useFrequencyCapsDispatch() {
  const context = React.useContext(FrequencyCapsDispatchContext);
  if (context === undefined) {
    throw new Error('useFrequencyCapsDispatch must be used within a FrequencyCapsProvider');
  }
  return context;
}

export { FrequencyCapsProvider, FrequencyCapsReducer, useFrequencyCapsState, useFrequencyCapsDispatch };
